export enum OktaSessionNames {
  CALLBACK_ROUTE = 'okta-callback-route',
  PROFILE = 'okta-profile',
  TRIGGER = 'okta-login-trigger',
}

export enum OktaFranklinIds {
  INTERNAL_ID = 'internalFranklinId',
}
